import { render, staticRenderFns } from "./ItemFilters.vue?vue&type=template&id=01860731&scoped=true&"
import script from "./ItemFilters.vue?vue&type=script&lang=ts&"
export * from "./ItemFilters.vue?vue&type=script&lang=ts&"
import style0 from "./ItemFilters.vue?vue&type=style&index=0&id=01860731&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01860731",
  null
  
)

export default component.exports